import { apiGet } from '../api'

export const get_all_users = query => {
  return apiGet({
    endpoint: query
      ? `user/get_all_users?${query}&sort=user_name:asc,user_surname:asc`
      : 'user/get_all_users'
  })
}
